import React from "react";
import { Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useHistory } from "react-router-dom";
import {
    POLL_TYPE,
    SHARED_ENTIRELY
} from "../../utils/constants";
import {getPollStatus, removePrefixNew} from "../../utils/helpers";
import styles from "./DashboardPage.module.css";
import { ReactComponent as RecentResultIcon } from "./images/gradient_table_icon.svg";
import { ReactComponent as NoResultIllustration } from "../../images/no_result.svg";
import {Button} from "@base-ui/react/button";
import { useTranslation } from "react-i18next";
import { translateDisplayValue } from "../../utils/displayLabel";
import OverflowText from "../../components/OverflowText";

export default function DashboardCardCompletedActivities({data=[], loading=true}) {
    const { t } = useTranslation();
    const history = useHistory();
    // const [selectedIndex, setSelectedIndex] = useState([]);

    const viewResult = (poll) => {
        const {pollKey, pollSortKey, pollType=POLL_TYPE.GRADED_POLL} = poll;
        history.push({
            pathname: "/gradebook",
            state : {
                pollKey : removePrefixNew(pollKey),
                uniqueCode: removePrefixNew(pollSortKey),
                pollType: pollType,
            }
        });
    }

    if (loading) {
        return (
            <div style={{flex: 1, height: 350}}>
                <Skeleton borderRadius={10} height={"100%"} width={"100%"}/>
            </div>
        );
    }

    return (
        <div className={styles.panelContainer} style={{display: "flex", flexDirection: "column", flex: 1}}>
            <div className={styles.panelTitle}>
                <RecentResultIcon style={{marginRight: "15px", flexShrink: 0, width: 18, height: 18}}/>
                <div>{t("questionBuilder.completedActivitiesText")}</div>
            </div>

            <div className={styles.panelBody}>
                {(!data || !data.length) &&
                    <>
                        <div style={{flex: 1}}/>
                        <NoResultIllustration style={{maxWidth: "100%", maxHeight: "100%", marginRight: "15px"}}/>
                        <span className={styles.noResultTitle} style={{marginTop: 40}}>
                            {t("poll.noCompletedActivities")}
                        </span>
                        <span className={styles.noResultDescription}>
                            {t("poll.noCompletedActivities")}
                        </span>
                        <div style={{flex: 1}}/>
                    </>
                }
                {(!!data && !!data.length) &&
                    <>
                        <div className={styles.panelDescription} style={{alignSelf: "start"}}>
                            {t("questionBuilder.completedActivitiesDescription")}
                        </div>
                        <div className={styles.tableWrapper}>
                            <Table className={styles.recentResultTable} hover>
                                <thead>
                                <tr>
                                    <th style={{width: 200, minWidth: 0, textAlign: "left"}}>
                                        {t("poll.activityTitleText")}
                                    </th>
                                    <th style={{width: 180, minWidth: 0}}>{t("table.statusColumn")}</th>
                                    <th style={{width: 120, minWidth: 0,}}>{t("table.actionHeader")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {JSON.parse(JSON.stringify(data)).splice(0, 5).map((poll, index) => {
                                    let pollStatus = getPollStatus(poll);
                                    let badgeClass = pollStatus === SHARED_ENTIRELY ? styles.releaseEntirely : styles.releaseSingle;

                                    return (
                                        <tr key={index} style={{cursor: "pointer"}} onClick={() => viewResult(poll)}>
                                            <td  className={styles.omitableText}
                                                style={{textAlign: "left"}}>{poll.pollTitle}</td>
                                            <td>
                                                <div style={{display: "flex"}}>
                                                    <span className={`${styles.badge} ${badgeClass}`}>
                                                       <OverflowText>{translateDisplayValue(pollStatus)}</OverflowText>
                                                    </span>
                                                </div>
                                            </td>
                                            <td >
                                                <div style={{display: "flex"}}>
                                                <Button
                                                    className={styles.gradientButton}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        viewResult(poll);
                                                    }}
                                                >
                                                    <OverflowText>{t("poll.gradeBookLabel")}</OverflowText>
                                                </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    );

                                })}
                                </tbody>
                            </Table>
                        </div>
                    </>

                }
            </div>
        </div>
    );
}